(function () {
  function initCardAutoplay() {
    if (window.innerWidth >= 750) return;

    document.querySelectorAll('.card__media').forEach(function (media) {
      var images = media.querySelectorAll('img');
      if (images.length < 2) return;

      var current = 0;

      // Imposta stato iniziale
      images[0].style.opacity = '1';
      images[0].style.transition = 'opacity 0.6s ease';
      images[1].style.opacity = '0';
      images[1].style.position = 'absolute';
      images[1].style.top = '0';
      images[1].style.left = '0';
      images[1].style.width = '100%';
      images[1].style.height = '100%';
      images[1].style.objectFit = images[0].style.objectFit || 'cover';
      images[1].style.transition = 'opacity 0.6s ease';

      setInterval(function () {
        if (current === 0) {
          images[0].style.opacity = '0';
          images[1].style.opacity = '1';
          current = 1;
        } else {
          images[0].style.opacity = '1';
          images[1].style.opacity = '0';
          current = 0;
        }
      }, 10000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardAutoplay);
  } else {
    setTimeout(initCardAutoplay, 300);
  }
})();